import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        user: null,
        items: [],
        patient: [],
        userDetails: null,
    },

    getters: {},

    mutations: {
        storeUser(state, user) {
            state.user = user;
        },
        storeItem(state, item) {
            state.items.push(item);
        },
        emptyItems(state) {
            state.items = [];
        },
        emptyUser(state) {
            state.user = null;
        },
        storeUserDetails(state, userDetails) {
            state.userDetails = userDetails;
        }
    },

    actions: {
        storeUser(context, user) {
            context.commit('storeUser', user)
        },
        storeItem(context, item) {
            context.commit('storeItem', item)
        },
        emptyItems(context) {
            context.commit('storeItem')
        },
        storeUserDetails(context, userDetails) {
            context.commit('storeUserDetails', userDetails)
        },
    }
});